var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',{staticClass:"el-tag",class:{
    [`el-tag--${_vm.type}`]: _vm.type,
    'is-inverse': _vm.inverse,
    'is-small': _vm.small
  },on:{"mouseenter":function($event){$event.stopPropagation();return _vm.handleMouseEnter.apply(null, arguments)},"mouseleave":function($event){$event.stopPropagation();return _vm.handleMouseLeave.apply(null, arguments)}}},[_c('span',{staticClass:"el-tag__text"},[_vm._t("default")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }